import TextEditor from './text_editor_new';

export default TextEditor;
